import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, Field } from 'react-final-form';
import { connect } from 'react-redux';
import { TextField, ClassificatorField } from '../../atoms';
import { Row, Col, Button, Spin } from 'antd';
import isEqual from 'lodash/isEqual';
import {
  FORM_MEASUREMENT,
  formRegisterMeasurementFields,
} from '../../constants/formRegister';
import { getProdUnitMeasurementAddState } from '../../reducers/prodUnitMeasurementPointReducer';
import { getLoadingSelector } from '../../utils/asyncHelpers';
import { parseNumber } from '../../utils/formHelpers';
import FormStateToRedux from '../FormStateToRedux';
import { makeRffValidateFromLegacy } from '../rffLegacyValidateAdapter';

import validateSchema from './validateSchema';

export class RegisterMeasurement extends Component {
  static propTypes = {
    productionUnitId: PropTypes.number,
    inEditForNotAdmin: PropTypes.bool.isRequired,
    closeForm: PropTypes.func.isRequired,
    isAdmin: PropTypes.bool.isRequired,
    isAvp: PropTypes.bool,
    isProduction: PropTypes.bool,
    initialValues: PropTypes.object,
    onSubmit: PropTypes.func.isRequired,
  };

  static defaultProps = {
    isAvp: false,
    isProduction: false,
  };

  render() {
    const {
      t,
      isLoading,
      closeForm,
      inEditForNotAdmin,
      isAdmin,
      isAvp,
      isProduction,
      initialValues,
      onSubmit,
    } = this.props;

    const isFieldDisabled = inEditForNotAdmin || isAvp;

    const validate = makeRffValidateFromLegacy(
      validateSchema,
      this.props,
      initialValues
    );

    return (
      <Spin spinning={isLoading}>
        <Form
          onSubmit={onSubmit}
          initialValues={initialValues}
          initialValuesEqual={isEqual}
          validate={validate}
          render={({ handleSubmit }) => (
            <form
              className="form-register-representation-company"
              onSubmit={handleSubmit}
            >
              <FormStateToRedux form={FORM_MEASUREMENT} />
              <h2>
                {isAvp
                  ? t('measurement.titleModalAvp')
                  : t('measurement.titleModal')}
              </h2>
              <Row gutter={32}>
                <Col span={12}>
                  <Field
                    label={t('measurement.countryLabel')}
                    name={formRegisterMeasurementFields.COUNTY}
                    component={ClassificatorField}
                    classificatorType={ClassificatorField.types.counties}
                    required
                    disabled={isFieldDisabled}
                  />
                </Col>
                <Col span={12}>
                  <Field
                    name={formRegisterMeasurementFields.CITY}
                    component={TextField}
                    type="text"
                    label={t('measurement.cityLabel')}
                    required
                    disabled={isFieldDisabled}
                  />
                </Col>
              </Row>
              <Row gutter={32}>
                <Col span={12}>
                  <Field
                    name={formRegisterMeasurementFields.DISTRICT}
                    component={TextField}
                    type="text"
                    label={t('measurement.districtLabel')}
                    required
                    disabled={isFieldDisabled}
                  />
                </Col>
                <Col span={12}>
                  <Field
                    name={formRegisterMeasurementFields.ADDRESS}
                    component={TextField}
                    type="text"
                    label={t('measurement.addressLabel')}
                    required
                    disabled={isFieldDisabled}
                  />
                </Col>
              </Row>
              <Row gutter={32}>
                <Col span={12}>
                  <Field
                    name={formRegisterMeasurementFields.ZIP_CODE}
                    component={TextField}
                    type="text"
                    parse={parseNumber}
                    label={t('measurement.zipCodeLabel')}
                    required
                    disabled={isFieldDisabled}
                  />
                </Col>
                <Col span={12}>
                  <Field
                    name={formRegisterMeasurementFields.EICZ_CODE}
                    component={TextField}
                    type="text"
                    label={t('measurement.eiczCodeLabel')}
                    required={isAdmin}
                    disabled={isFieldDisabled || !isAdmin}
                  />
                </Col>
              </Row>
              {isProduction && (
                <Row gutter={32}>
                  <Col span={12}>
                    <Field
                      name={formRegisterMeasurementFields.DISSEMINATION_LEVEL}
                      component={ClassificatorField}
                      classificatorType={
                        ClassificatorField.types.disseminationLevel
                      }
                      label={t('measurement.headerDisseminationLevel')}
                      required
                      disabled={inEditForNotAdmin}
                    />
                  </Col>
                </Row>
              )}
              <div className="component-register-actions">
                <Button
                  className="component-register-actions__button-previous"
                  size="large"
                  onClick={closeForm}
                >
                  {inEditForNotAdmin
                    ? t('measurement.buttonClose')
                    : t('measurement.buttonCancel')}
                </Button>
                {!inEditForNotAdmin && (
                  <Button
                    className="component-register-actions__button-next"
                    size="large"
                    type="primary"
                    htmlType="submit"
                  >
                    {isAvp
                      ? t('measurement.buttonSaveAvp')
                      : t('measurement.buttonSaveVirtual')}
                  </Button>
                )}
              </div>
            </form>
          )}
        />
      </Spin>
    );
  }
}

const mapStateToProps = (state) => {
  const isLoading = getLoadingSelector(getProdUnitMeasurementAddState)(state);

  return {
    isLoading,
  };
};

export default connect(mapStateToProps)(RegisterMeasurement);
